<template lang="pug">
transition(name='loading')
  #loading
    progress-bar(:progress="loading.progress")
    animated-number(
      :number="loading.progress * 100"
      :time="200"
      :digits="0"
    )
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import ProgressBar from 'src/components/_utils/ProgressBar'
import AnimatedNumber from 'src/components/_utils/AnimatedNumber'
import AssetService from 'src/services/AssetService'
import MediaService from 'src/services/MediaService'
import SoundService from 'src/services/SoundService'

export default {
  name: 'loading',
  components: {
    ProgressBar,
    AnimatedNumber,
  },
  data() {
    return {
      progress: {
        assets: 0,
        media: 0,
        sounds: 0,
      },
      startTime: Date.now(),
      updateTime: 100,
      minTime: 1000,
    }
  },
  computed: {
    ...mapState('app', ['loading', 'debug', 'route']),
  },
  mounted() {
    if (this.debug) this.minTime = 0

    AssetService.on(AssetService.Events.PROGRESS, this.onAssetsProgress)
    MediaService.on(MediaService.Events.PROGRESS, this.onMediaProgress)
    SoundService.on(SoundService.Events.PROGRESS, this.onSoundsProgress)
    this.interval = setInterval(this.update)
  },
  beforeDestroy() {
    AssetService.off(AssetService.Events.PROGRESS, this.onAssetsProgress)
    MediaService.off(MediaService.Events.PROGRESS, this.onMediaProgress)
    SoundService.off(SoundService.Events.PROGRESS, this.onSoundsProgress)
    clearInterval(this.interval)
  },
  methods: {
    ...mapMutations('app', ['setLoadProgress']),
    onAssetsProgress(data) {
      this.progress.assets = data
    },
    onMediaProgress(data) {
      this.progress.media = data
    },
    onSoundsProgress(data) {
      this.progress.sounds = data
    },
    update() {
      let actualProgress = 0
      actualProgress += this.progress.assets / 3
      actualProgress += this.progress.media / 3
      actualProgress += this.progress.sounds / 3

      let maxProgress = (Date.now() - this.startTime) / this.minTime
      maxProgress = Math.min(maxProgress, 1)

      let showProgress = Math.min(actualProgress, maxProgress)
      showProgress = Math.min(showProgress, 1)

      this.setLoadProgress(showProgress)

      if (this.loading.completed && maxProgress >= 1) {
        this.next()
      }
    },
    next() {
      this.setLoadProgress(1)

      // on delay so you see 100%
      setTimeout(() => {
        this.$router.replace(this.route.afterLoad).catch(err => {})
      }, 250)
    },
  },
}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"

#loading
  +full()
  +flex-center()
  background: white
  .progress-bar
    position: absolute

.loading-leave-active
  transition: all 0.5s ease 0s
  opacity: 0
</style>
